import {TimePicker as MuiTimePicker} from "@mui/x-date-pickers"
import React from "react";
import {Time} from "../../time/DateTime";
import {DateTime} from "luxon";

interface TimePickerProps{
    value: Time|null
    label: string
    onChange: (value: Time|null) => void
}

export const TimePicker = ({value, label, onChange}:TimePickerProps)=>{

   const wrapOnChange= (f: DateTime|null)=>{

       const timeFrom = f? Time.fromString(f.hour + ":" + f.minute) : f
       onChange(timeFrom)
    }

    const wrapOnChangeString= (f: string|null)=>{

       const timeFrom: Time|null = f !=null ? Time.fromString(f) : f
       onChange(timeFrom)
    }


    return <MuiTimePicker value={value? value.asDateTime().raw() : null} label={label} onAccept={(f)=> wrapOnChange(f)}
                          slotProps={{
                              textField: {
                                  onBlur: (f) => {
                                      wrapOnChangeString(f.target.value)
                                  },
                              },
                          }}
                              />
}